module.exports = __webpack_public_path__ + "img/keder_alugrau_ral7037.11b1f9ed.jpg";